<template>
    <div>
        <div id="map" class="focus:outline-0" style="height:400px;">
            <div class="container mx-auto relative" style="z-index: 400">
                <div id="app" class="absolute bg-grey-lighter text-grey-dark font-weight-600 uppercase px-10 py-4 text-lg mt-4 rounded-full text-center" style="z-index: 400">
                    <strong>recent location</strong><br />
                    <span class="text-sm">5 minutes ago</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as mapboxgl from 'mapbox-gl'

    export default {
        name: 'ChaserMap',
        data() {
            return {
                map: null,
            }
        },
        props: [
            'type'
        ],
        mounted() {
            this.initializeMap()
        },
        methods: {
            initializeMap() {
                this.map = new mapboxgl.Map({
                    container: 'map',
                    style: 'https://tiles.livestormchasing.com/styles/dark-matter/style.json',
                    center: [-72.58283971246843, 42.09636423291184],
                    zoom: 4,
                });
            },
        },
        created () {
            document.addEventListener('click', this.documentClick)
        },
        destroyed () {
            // important to clean up!!
            document.removeEventListener('click', this.documentClick)
        }
    }
</script>
